import React from "react";
import Link from "next/link";
import styles from "@styles/post/text.module.css";
import { TAG_TYPE } from "@utils/constants";
//import { printInConsole } from "./devTools";
const urlRegex = /(https?:\/\/[^\s]+)/g;

function urlify(text) {
  const isLink = text?.match(urlRegex)?.length > 0;
  if (isLink)
    return (
      <Link
        href={text}
        target="_blank"
        style={{ textDecoration: "underline" }}
        onClick={(e) => e.stopPropagation()}
      >
        {text}
      </Link>
    );
  else return text;
}

export default function getText(text, userTagList, viewHashtagPost) {
  if (!text || typeof text !== "string") return "";

  const txt = text.split("\n");
  if (userTagList === null || userTagList === undefined) userTagList = [];

  function hashtagOnClickHandler(e, value) {
    if (e) e.stopPropagation();

    if (viewHashtagPost) viewHashtagPost(value.substring(1));
  }

  function renderHashtag(word) {
    return (
      <span
        className={styles.hashtag}
        onClick={(e) => hashtagOnClickHandler(e, word)}
      >
        {word + " "}
      </span>
    );
  }

  function RenderUserTag({ data }) {
    let name = "";
    let otherTxt = "";
    let uid = "";
    let url = "";

    for (let i = 0; i < userTagList.length; i++) {
      const obj = userTagList[i];

      if (obj.tagType === TAG_TYPE.USER_TAGGING && data.includes(obj.uid)) {
        uid = obj.uid;
        otherTxt = data.replace(obj.uid, "");
        name = obj.User.name;
        url = `/profile/${obj.uid}`;
        break;
      }

      if (
        obj.tagType === TAG_TYPE.COMMUNITY_TAGGING &&
        data.includes(obj.communityID)
      ) {
        uid = obj.communityID;
        otherTxt = data.replace(obj.communityID, "");
        name = obj.Community?.name;
        url = `/community/${obj.communityID}`;
        break;
      }
    }

    if (name === "") {
      return (
        <>
          <span>{"@" + data + " "}</span>
        </>
      );
    } else {
      return (
        <>
          <span onClick={(e) => e.stopPropagation()}>
            <Link
              scroll={false}
              href={url}
            >
              <span className={styles.userTag}>{name}</span>
            </Link>
            {urlify(otherTxt)}{" "}
          </span>
        </>
      );
    }
  }

  function RenderText({ word }) {
    if (word.indexOf("@") !== -1) {
      const w = word.split("@");
      const m = w.slice(1);

      if (word[0] === "#") return renderHashtag(word);
      else {
        return (
          <>
            {urlify(w[0])}
            {m &&
              m.map((item, index) => (
                <RenderUserTag key={index.toString()} data={item} />
              ))}
          </>
        );
      }
    } else if (word[0] === "#") {
      return renderHashtag(word);
    }

    return <>{urlify(word)} </>;
  }

  function RenderLine({ text, firstLine }) {
    if (text === "") return <br />;

    return (
      <>
        {!firstLine && <br style={{ margin: 0 }} />}
        {text.split(" ").map((data, index) => {
          return <RenderText key={index.toString()} word={data} />;
        })}
      </>
    );
  }

  return (
    <>
      {txt.map((data, index, arr) => {
        if (index === arr.length - 1 && data === "") return "";

        return (
          <RenderLine
            key={index.toString()}
            text={data}
            firstLine={index === 0 ? true : false}
          />
        );
      })}
    </>
  );
}
